export default {
  default: 'default',
  organization: 'organization',
  assignedToMe: 'assignedToMe'
};
